import React from 'react';

import {Menu, Sticky, Grid, Container} from 'semantic-ui-react'
import {menuItems} from './header'
import {resume} from './resume'
import Summary from './summary'
import Education from './education'
import Experience from './experience'
import Publication from './publication'
var scrollToElement = require('scroll-to-element')

export default class Main extends React.Component {
    isMobile = false;
    state = { activeItem: 'About', screenSize: 'normal'}
    childRefsList = {}

    componentDidMount() {
        this.windowUpdate();
        window.addEventListener("resize", this.windowUpdate.bind(this));
    }

    componentWillMount() {
        this.isMobile = window.innerWidth <= 800;
    }

    windowUpdate(event) {
        if (window.innerWidth <= 800) {
            this.isMobile = true;
            this.setState({screenSize: 'small'})
        } else {
            this.isMobile = false;
            this.setState({screenSize: 'normal'})
        }
    }

    handleItemClick = (e, { name }) => {
        this.setState({ activeItem: name })

        const responsiveOffset = this.isMobile ? -10 : -50
        scrollToElement('#'+name.toLowerCase().replace(' ', '_'), {offset:responsiveOffset})
    }

    handleContextRef = contextRef => this.setState({ contextRef })

    MenuCotainer = () => {
        const {contextRef} = this.state;
        const contentWidth = this.isMobile ? 16 : 12;
        if (!this.isMobile) {
            return (
                <Sticky context={contextRef} className='navigation_bar'>
                    <Grid.Row centered columns={3}>
                        <Grid.Column width={contentWidth}>
                            <Menu secondary>
                                {menuItems.map((info) => (
                                    <Menu.Item
                                        name={info.name}
                                        onClick={this.handleItemClick}
                                        key={info.name}
                                    >
                                    </Menu.Item>
                                ))}
                                <Menu.Item
                                    name='Resume'
                                    key='resume_menu'
                                    href={resume.social.resume}
                                    target='_blank'
                                />         
                            </Menu>
                        </Grid.Column>
                    </Grid.Row>
                </Sticky>
            );
        } else {
            return null
        }
    }

    render() {
        const menuBar = this.MenuCotainer();
        const contentWidth = this.isMobile ? 16 : 12;
        const columnNums = this.isMobile ? 1 : 3;
        const mobile = this.isMobile ? 'mobile' : ''
        return (
            <div ref={this.handleContextRef}>
                <Grid verticalAlign='top' divided>
                        {menuBar}
                    <Grid.Row className={["content", mobile].join(' ')} centered columns={columnNums}>
                        <Grid.Column width={contentWidth}>
                            <Container className="content_container">
                                <Summary />
                                <Education />
                                <Experience />
                                <Publication />
                            </Container>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Infos/main.js